var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react')
var Select = dynamicRequire('Select.jsx');
var resolveLanguage = dynamicRequire('resolveLanguage');
var Mssg = dynamicRequire('Mssg.jsx');

class Foam extends React.Component {

    render() {
        const {props} = this;
        let selectKey = this.props.foams.reduce((prev, foam) => {return foam.partName + prev}, '');
        return <div className="lr-casefactory-choices-options-option option clearfix">
            <Mssg __key="nc_casefactory.foam" /><br />
            {(props.foamId) ? <Mssg __key="nc_casefactory.foam.notice"/> : ''}
            <Select
                key={selectKey}
                className="lr-style"
                choiceHandler={(value) => {
                    this.context.emitter.emit('foam', value)
                }}
                active={props.foamId || ''}
                options={this.getFoamOptions(props.foams)}
            />
        </div>
    }

    getFoamOptions(foams) {
        // we want the default as an option because it is a legitimate action to deselect an option (and getting an event for it)
        var defaultOption = {
            value: '',
            name: resolveLanguage('nc_casefactory.no.foam')
        };
        var foamOptions =  foams.map(foam => {
            var label = foam.partName ? foam.partName : resolveLanguage("nc_casefactory.part.name." + foam.articleNumber);
            return {value: foam.id, name:label}
        })

        return [defaultOption, ...foamOptions]
    }
}

Foam.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};


module.exports = Foam;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Options/Foam.jsx